/**
 * @public
 */
export type CircularProgressSize =
    | 'x-small'
    | 'small'
    | 'medium'
    | 'large'
    | 'x-large';
